<script>
import {mixin_page_table} from "@/utils/mixin";
import {getAccompanies, getApproves, getInvalidPendingAppliesByEmployeeId, getMakeCopies, getTransfers} from "@/api/mobile/mobile-apply-api";
import {getFileUrl} from "@/utils/fileUploadUtils";
import {getVisitorByBatch} from "@/api/mobile/mobile-visitor-api";
import {getEmployeeByBatch} from "@/api/mobile/mobile-employee-api";
import PendingProgressView from "@/pages/visitJobs/comp/PendingProgressView.vue";
import PendingTransferInfoView from "@/pages/visitJobs/comp/PendingTransferInfoView.vue";
import {getInviteVisitorFormSettingWithMobile} from "@/api/mobile/mobile-setting-api";

export default {
  name: "ApplyingRecordHistoryView",
  components: {PendingTransferInfoView, PendingProgressView},
  mixins: [mixin_page_table],
  props: ["areaMap"],
  data() {
    return {
      drawerData: {
        employee: {name: "", tel: "", workId: "",},
        visitor: {name: "", tel: "", company: "",},
        formInfo: [],
        peerList: [],

        approveData: [],  // 审批进度
        copyData: [],     //  抄送列表
        transferInfo: [], // 转签信息
      },

      employeeMap: {},

      selectPending: {},
      detailDrawerShow: false,

      visitorSetting: {
        idCardNo: 2, // 身份证号设置  1不展示， 2选填， 3必填; 默认选填
        nationality: 1, // 国籍设置  1不展示， 2选填， 3必填； 默认不展示
      },
    }
  },

  mounted() {
    this.refreshTableData()
    getInviteVisitorFormSettingWithMobile().then(({data}) => {
      console.log("getInviteVisitorFormSettingWithMobile", data)
      if (data.code === 200) {
        data.data.forEach(item => {
          if (item.type === "VISITOR_INVITE") {
            let content = JSON.parse(item.content)
            if (content) {
              this.visitorSetting.idCardNo = content.idCardNo
              this.visitorSetting.nationality = content.nationality
            }
          }
        })
      }
    }).catch((err) => {
      this.showNetErrMsg(err)
    })
  },

  methods: {
    showDetail(row) {
      console.log("showDetail => ", row)
      let employeeHead = require('@/assets/default_header.webp')
      if (row.employee && row.employee.head) {
        employeeHead = getFileUrl(row.employee.head)
      }
      let visitorHead = require('@/assets/default_header.webp')
      if (row.visitor.head) {
        visitorHead = getFileUrl(row.visitor.head)
      }
      this.drawerData = {
        employee: {name: "", tel: "", workId: "",},
        visitor: {name: "", tel: "", company: "",},
        formInfo: [],
        peerList: [],
        approveData: [],  // 审批进度
        copyData: [],     //  抄送列表
        transferInfo: [], // 转签信息
      }
      if (row.visitorCardNo) {
        this.$set(row.visitor, "preCardNo", row.visitorCardNo)
      }
      this.drawerData.peerList.push(row.visitor)
      if (row.employee) {
        this.drawerData.employee = {
          headUrl: employeeHead, name: row.employee.name, tel: row.employee.tel, workId: row.employee.workId,
        }
      } else {
        this.drawerData.employee = {
          headUrl: employeeHead, name: "", tel: "", workId: "",
        }
      }

      this.drawerData.visitor = {
        headUrl: visitorHead, name: row.visitor.name, tel: row.visitor.tel, company: row.visitor.company,
      }
      let showInfo = []
      if (row.entryArea) {
        let area = this.areaMap[row.entryArea]
        let superArea = area ? this.areaMap[area.parentId] : null
        if (area && superArea) {
          showInfo.push({
            label: "到访区域",
            value: superArea.name + "，" + area.name
          })
        }
      }
      showInfo.push({label: "开始时间", value: row.beginDate + " " + row.beginTime.substring(0, 5), key: "beginTime"})
      showInfo.push({label: "结束时间", value: row.endDate + " " + row.endTime.substring(0, 5), key: "endTime"})
      if (row.forms) {
        row.forms.forEach(item => {
          if (item.name !== "startTime" && item.name !== "endTime" && item.name !== "peer") {
            showInfo.push({label: item.title, value: item.value, key: item.name})
          }
        })

      }
      // 同行人
      let codes = []
      getAccompanies(row.id).then(({data}) => {
        console.log("getAccompanies => ", data);

        if (data.code === 200) {
          data.data.forEach(item => {
            if (!codes.includes(item.visitorCode)) {
              codes.push(item.visitorCode)
            }
          })
        }
        getVisitorByBatch(codes).then(({data}) => {
          if ((data.code === 200) && (data.data != null)) {
            let accompanyCards = row.accompanyCards ? row.accompanyCards : {}
            data.data.forEach(item => item.preCardNo = accompanyCards[item.code])
            this.drawerData.peerList.push(...data.data)
          }
        }).catch((err) => {
          console.log("getVisitorByBatch => ", err);
        })
      }).catch((err) => {
        console.log("getAccompanies => ", err);
      })

      // 审批进度
      getApproves(row.id).then(({data}) => {
        console.log("getApproves => ", data);
        if (data.code === 200) {
          this.drawerData.approveData = data.data

          let newEmployeeCodes = []
          this.drawerData.approveData.forEach(item => {
            if (this.employeeMap[item.employeeCode]) {
              this.$set(item, 'employeeName', this.employeeMap[item.employeeCode].name)
            } else {
              this.$set(item, 'employeeName', "")

              if (!newEmployeeCodes.includes(item.employeeCode)) {
                newEmployeeCodes.push(item.employeeCode)
              }
            }
          })
          if (newEmployeeCodes.length === 0) {
            return
          }
          getEmployeeByBatch(newEmployeeCodes).then(({data}) => {
            console.log("getEmployeeByBatch => ", data);
            if (data.code === 200) {
              data.data.forEach(item => {
                this.employeeMap[item.code] = item
              })
              let newApproveData = []

              this.drawerData.approveData.forEach(item => {
                item.employeeName = this.employeeMap[item.employeeCode].name
                newApproveData.push(item)
              })
              this.drawerData.approveData = newApproveData
            }
          }).catch((err) => {
            console.log("getEmployeeByBatch => ", err);
          })
        }
      }).catch((err) => {
        console.log("getApproves => ", err);
      })


      getMakeCopies(row.id).then(({data}) => {
        console.log("getMakeCopies => ", data);
        if (data.code === 200) {
          this.drawerData.copyData = data.data
          let newEmployeeCodes = []
          this.drawerData.copyData.forEach(item => {
            if (this.employeeMap[item.employeeCode]) {
              this.$set(item, 'employeeName', this.employeeMap[item.employeeCode].name)
            } else {
              this.$set(item, 'employeeName', "")

              if (!newEmployeeCodes.includes(item.employeeCode)) {
                newEmployeeCodes.push(item.employeeCode)
              }
            }
          })
          if (newEmployeeCodes.length === 0) {
            return
          }
          getEmployeeByBatch(newEmployeeCodes).then(({data}) => {
            console.log("getEmployeeByBatch => ", data);
            if (data.code === 200) {
              data.data.forEach(item => {
                this.employeeMap[item.code] = item
              })
              let newCopyData = []
              this.drawerData.copyData.forEach(item => {
                item.employeeName = this.employeeMap[item.employeeCode] ? this.employeeMap[item.employeeCode].name : ""
                newCopyData.push(item)
              })
              this.drawerData.copyData = newCopyData
            }
          }).catch((err) => {
            console.log("getEmployeeByBatch => ", err);
            this.showServerErrMsg(err)
          })
        }
      }).catch((err) => {
        console.log("getMakeCopies => ", err);
      })

      getTransfers(row.id).then(({data}) => {
        console.log("getTransfers => ", data);
        if (data.code === 200) {
          this.drawerData.transferInfo = data.data
          let newEmployeeCodes = []
          this.drawerData.transferInfo.forEach(item => {
            if (item.fromEmployeeCode) {
              if (this.employeeMap[item.fromEmployeeCode]) {
                this.$set(item, 'fromEmployeeName', this.employeeMap[item.fromEmployeeCode].name)
              } else {
                this.$set(item, 'fromEmployeeName', "")

                if (!newEmployeeCodes.includes(item.fromEmployeeCode)) {
                  newEmployeeCodes.push(item.fromEmployeeCode)
                }
              }
            }
            if (item.toEmployeeCode) {
              if (this.employeeMap[item.toEmployeeCode]) {
                this.$set(item, 'toEmployeeName', this.employeeMap[item.toEmployeeCode].name)
              } else {
                this.$set(item, 'toEmployeeName', "")

                if (!newEmployeeCodes.includes(item.toEmployeeCode)) {
                  newEmployeeCodes.push(item.toEmployeeCode)
                }
              }
            }
          })
          if (newEmployeeCodes.length === 0) {
            return
          }
          getEmployeeByBatch(newEmployeeCodes).then(({data}) => {
            console.log("getEmployeeByBatch => ", data);
            if (data.code === 200) {
              data.data.forEach(item => {
                this.employeeMap[item.code] = item
              })
              let newTransferInfo = []
              this.drawerData.transferInfo.forEach(item => {
                if (item.fromEmployeeCode) {
                  item.fromEmployeeName = this.employeeMap[item.fromEmployeeCode] ? this.employeeMap[item.fromEmployeeCode].name : ""
                }
                if (item.toEmployeeCode) {
                  item.toEmployeeName = this.employeeMap[item.toEmployeeCode] ? this.employeeMap[item.toEmployeeCode].name : ""
                }
                newTransferInfo.push(item)
              })
              this.drawerData.transferInfo = newTransferInfo
            }
          }).catch((err) => {
            console.log("getEmployeeByBatch => ", err);
            this.showServerErrMsg(err)
          })
        }
      }).catch((err) => {
        console.log("getTransfers => ", err);
      })

      this.drawerData.formInfo = showInfo
      this.selectPending = row
      this.detailDrawerShow = true
    }, // showDetail end


    refreshTableData() {
      this.tableData = []
      let pageIndex = this.curPageIndex
      let pageSize = this.curPageSize
      getInvalidPendingAppliesByEmployeeId(pageIndex, pageSize).then(({data}) => {
        if (data.code === 200 && data.data != null) {
          this.tableData.push(...data.data.data)
          this.totalCount = data.data.totals
        }
      }).catch(err => {
        console.log("refreshTableData => ", err)
      })

    },
  },
  filters: {
    timeShowFilter(value) {
      if (value === null || value.length < 19) {
        return value
      } else {
        return value.substring(0, 10) + " " + value.substring(11, 16)
      }
    },
    applyTypeFilter(value) {
      if (value === "BOOK_APPLY") {
        return "预约"
      } else if (value === "INVITE_APPLY") {
        return "邀约"
      } else {
        return "其他"
      }
    },
    roleFilter(value) {
      if (value === "EMPLOYEE_VISITED") {
        return "被访者"
      } else if (value === "EMPLOYEE_APPROVED") {
        return "审核者"
      } else if (value === "EMPLOYEE_MAKECOPY") {
        return "抄送者"
      } else if (value === "EMPLOYEE_TRANSFER") {
        return "转签者"
      } else {
        return "其他"
      }
    }
  },

}
</script>

<template>
  <div>
    <el-drawer title="详情" class="drawer-box" :visible.sync="detailDrawerShow" :with-header="false" size="600px">
      <div class="drawer-head">
        <div class="drawer-title">详细信息</div>
        <button @click="detailDrawerShow = false" class="el-drawer__close-btn"><i class="el-icon-close"></i></button>
      </div>
      <div class="drawer-line"></div>
      <div class="drawer-content">
        <el-row>
          <el-col :span="12">
            <div class="grid-content">
              <h4>员工信息</h4>
              <div class="input-item-box"><span class="input-description">头像：</span>
                <el-image class="image-header" :src="drawerData.employee.headUrl" fit="cover">
                </el-image>
              </div>
              <div class="input-item-box"><span class="input-description">姓名：</span>
                <el-input size="mini"
                          v-model="drawerData.employee.name" :disabled="true" class="input-short"></el-input>
              </div>
              <div class="input-item-box"><span class="input-description">手机：</span>
                <el-input size="mini"
                          v-model="drawerData.employee.tel" :disabled="true" class="input-short"></el-input>
              </div>
              <div class="input-item-box"><span class="input-description">工号：</span>
                <el-input size="mini"
                          v-model="drawerData.employee.workId" :disabled="true" class="input-short"></el-input>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="grid-content">
              <h4>访客信息</h4>
              <div class="input-item-box"><span class="input-description">头像：</span>
                <el-image class="image-header" :src="drawerData.visitor.headUrl" fit="cover">
                </el-image>
              </div>
              <div class="input-item-box"><span class="input-description">姓名：</span>
                <el-input size="mini"
                          v-model="drawerData.visitor.name" :disabled="true" class="input-short"></el-input>
              </div>
              <div class="input-item-box"><span class="input-description">手机：</span>
                <el-input size="mini"
                          v-model="drawerData.visitor.tel" :disabled="true" class="input-short"></el-input>
              </div>
              <div class="input-item-box"><span class="input-description">公司：</span>
                <el-input size="mini"
                          v-model="drawerData.visitor.company" :disabled="true" class="input-short"></el-input>
              </div>
            </div>

          </el-col>
        </el-row>
        <div class="grid-content">
          <h4>表单信息</h4>
          <div v-for="item in drawerData.formInfo" :key="item.key" class="input-item-box">
            <span class="input-description-long">{{ item.label }}:</span>
            <el-input size="mini" :placeholder="item.value" :disabled="true" class="input-long"></el-input>
          </div>
          <!--          <div v-for="(item, index) in drawerData.peerList" :key="index" class="input-item-box">-->
          <!--            <span class="input-description-long">同行人员:</span>-->
          <!--            <el-input size="mini" :placeholder="item.name" :disabled="true" class="input-long"></el-input>-->
          <!--          </div>-->
        </div>

        <div class="grid-content ">
          <h4>访客信息</h4>
          <el-table :data="drawerData.peerList" border stripe size="mini">
            <el-table-column prop="name" label="访客姓名" width="70"></el-table-column>
            <el-table-column prop="tel" label="访客手机" width="100"></el-table-column>
            <el-table-column prop="preCardNo" label="访客卡号" width="70"></el-table-column>
            <el-table-column prop="ic" label="身份证号" v-if="visitorSetting.idCardNo !== 1" width="170">
              <template v-slot="scope">
                {{ scope.row.ic  | icNoFilter}}
              </template>
            </el-table-column>
            <el-table-column prop="nationality" label="访客国籍" v-if="visitorSetting.nationality !== 1 " width="70"></el-table-column>
            <el-table-column prop="company" label="访客公司"></el-table-column>
          </el-table>
        </div>

        <div class="grid-content" v-if="drawerData.copyData.length > 0">
          <h4>抄送列表</h4>
          <div v-for="(item, index) in drawerData.copyData" :key="index" class="input-item-box">
            <span class="input-description-long">抄送人员</span>
            <el-input size="mini" :placeholder="item.employeeName" :disabled="true" class="input-long"></el-input>
          </div>
        </div>

        <PendingTransferInfoView style="margin: 20px"
                                 :transferInfoData="drawerData.transferInfo"></PendingTransferInfoView>
        <PendingProgressView style="margin: 20px" :pendingProgressData="drawerData.approveData"
                             :applyData="selectPending"></PendingProgressView>
      </div>
      <div class="drawer-line"></div>
      <div class="drawer-bottom">
        <el-button size="mini" @click="detailDrawerShow = false">返回</el-button>
      </div>
    </el-drawer>

    <el-table :data="tableData" border>
      <el-table-column label="访客姓名" width="120px">
        <template v-slot="scope">
          <span>{{ scope.row.visitor.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="访客号码" width="120px">
        <template v-slot="scope">
          <span>{{ scope.row.visitor.tel }}</span>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" width="140px">
        <template v-slot="scope">
          <span>{{ scope.row.createTime | timeShowFilter }}</span>
        </template>
      </el-table-column>
      <el-table-column label="申请类型" width="80px">
        <template v-slot="scope">
          <el-tag>{{ scope.row.type | applyTypeFilter }}</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="开始时间" width="140px">
        <template v-slot="scope">
          <span>{{ scope.row.beginDate }} {{ scope.row.beginTime.substring(0, 5) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="结束时间" width="140px">
        <template v-slot="scope">
          <span>{{ scope.row.endDate }} {{ scope.row.endTime.substring(0, 5) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="我的身份">
        <template v-slot="scope">
          <el-tag v-for="item in scope.row.related.split('|')" style="margin: 2px" :key="item">{{
              item | roleFilter
            }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column label="查看" width="80px">
        <template v-slot="scope">
          <el-button type="primary" size="mini" @click="showDetail(scope.row)">查看</el-button>
        </template>
      </el-table-column>

    </el-table>
    <div class="pager">
      <el-pagination layout="sizes, prev, pager, next" :total="totalCount" :page-sizes="pageSizes"
                     :page-size.sync="curPageSize" :pager-count="5"
                     :current-page.sync="curPageIndex" @size-change="handleSizeChange"
                     @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>

</template>

<style lang="less" scoped>
.nav {
  padding-bottom: 10px;

  .nav-item {
    margin-right: 15px;
  }
}

/deep/ .el-radio-button__inner {
  background-color: #efefef;
}

::v-deep .el-radio-button:first-child .el-radio-button__inner {
  border-radius: 60px;
}

::v-deep .el-radio-button:last-child .el-radio-button__inner {
  border-radius: 60px;
}

.main-content {
  background-color: white;
  //padding: 10px;

  .tab-title {
    font-weight: 550;
    font-size: 16px;
  }
}

.content {
  background-color: white;
}


.drawer-content {

  .input-short {
    width: 150px;
  }

  .input-long {
    width: 400px;
  }

  .grid-content {
    //padding-left: 8px;
    margin: 8px 8px 8px 20px;

  }

  .input-item-box {
    display: flex;
    flex-direction: row;
    align-items: start;
    padding-bottom: 8px;
    font-size: 14px;
  }

  .input-description {
    display: inline-block;
    width: 80px;
  }

  .input-description-long {
    display: inline-block;
    width: 120px;
  }
}

.image-header {
  width: 80px;
  height: 100px;
}
</style>

